import { useScrollFadeIn, staggerStyle } from "@/hooks/useScrollFadeIn";

const snsAccounts = [
  {
    id: 1,
    label: 'むぎ茶',
    platform: 'X (Twitter)',
    handle: '@mazo_kawaii',
    desc: 'メインアカウント　活動や動画',
    url: 'https://x.com/mazo_kawaii',
    icon: 'ri-twitter-x-line',
    badge: 'MAIN',
    badgeColor: 'bg-stone-800 text-white',
    iconBg: 'bg-stone-800',
    iconColor: 'text-white',
  },
  {
    id: 2,
    label: 'からだめぐりむぎ茶',
    platform: 'X (Twitter)',
    handle: '@mazo_kawaii2',
    desc: 'サブアカウント　日常と性癖',
    url: 'https://x.com/mazo_kawaii2',
    icon: 'ri-twitter-x-line',
    badge: 'SUB',
    badgeColor: 'bg-amber-100 text-amber-700',
    iconBg: 'bg-amber-100',
    iconColor: 'text-amber-700',
  },
  {
    id: 3,
    label: 'お仕置きBAR【公式】',
    platform: 'X (Twitter)',
    handle: '@osioki_bar',
    desc: 'お仕置きBAR開催情報・イベント告知',
    url: 'https://x.com/osioki_bar',
    icon: 'ri-twitter-x-line',
    badge: 'BAR',
    badgeColor: 'bg-rose-100 text-rose-700',
    iconBg: 'bg-rose-100',
    iconColor: 'text-rose-700',
  },
];

export default function BlogSNSSection() {
  const { ref: blogRef, style: blogStyle } = useScrollFadeIn<HTMLDivElement>({ threshold: 0.08, delay: 0 });
  const { ref: linksRef, style: linksStyle } = useScrollFadeIn<HTMLDivElement>({ threshold: 0.08, delay: 0 });
  const { ref: snsHeadRef, style: snsHeadStyle } = useScrollFadeIn<HTMLDivElement>({ threshold: 0.08, delay: 0 });
  const { ref: snsGridRef, visible: snsVisible } = useScrollFadeIn<HTMLDivElement>({ threshold: 0.06, delay: 0.05 });

  return (
    <section id="blog" className="py-10 md:py-14 bg-white">
      <div className="max-w-4xl mx-auto px-6 md:px-10">

        {/* Blog */}
        <div ref={blogRef} style={blogStyle} className="mb-12">
          <div className="flex items-center gap-3 mb-5">
            <div className="w-7 h-7 flex items-center justify-center">
              <i className="ri-book-open-line text-stone-400 text-lg"></i>
            </div>
            <p className="text-xs tracking-[0.4em] text-stone-400 uppercase">Blog</p>
            <div className="flex-1 h-px bg-stone-200"></div>
          </div>

          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-5 pl-10">
            <div>
              <a
                href="https://muginox.hatenablog.com/"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="group inline-block cursor-pointer"
              >
                <h3
                  className="font-en text-2xl md:text-3xl font-light text-stone-700 tracking-widest group-hover:text-stone-500 transition-colors duration-300 mb-1"
                >
                  むぎ茶の資料室
                </h3>
                <p className="text-xs text-stone-400 tracking-widest">muginox.hatenablog.com</p>
              </a>
              <p className="text-sm text-stone-500 mt-2 leading-relaxed whitespace-nowrap">
                日々の思いやプレイの記録を綴っています。
              </p>
            </div>
            <a
              href="https://muginox.hatenablog.com/"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="inline-flex items-center gap-2 px-7 py-2.5 border border-stone-300 text-stone-600 text-xs tracking-[0.3em] hover:bg-stone-800 hover:text-white hover:border-stone-800 transition-all duration-300 cursor-pointer whitespace-nowrap flex-shrink-0"
            >
              <i className="ri-book-open-line text-xs"></i>
              ブログを読む
            </a>
          </div>
        </div>

        {/* lit.link */}
        <div ref={linksRef} style={linksStyle} className="mb-12">
          <div className="flex items-center gap-3 mb-5">
            <div className="w-7 h-7 flex items-center justify-center">
              <i className="ri-links-line text-stone-400 text-lg"></i>
            </div>
            <p className="text-xs tracking-[0.4em] text-stone-400 uppercase">Links</p>
            <div className="flex-1 h-px bg-stone-200"></div>
          </div>

          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-5 pl-10">
            <div>
              <a
                href="https://lit.link/hatomugicha91"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="group inline-block cursor-pointer"
              >
                <h3
                  className="font-en text-2xl md:text-3xl font-light text-stone-700 tracking-widest group-hover:text-stone-500 transition-colors duration-300 mb-1"
                >
                  lit.link
                </h3>
                <p className="text-xs text-stone-400 tracking-widest">lit.link/hatomugicha91</p>
              </a>
              <p className="text-sm text-stone-500 mt-2 leading-relaxed">
                最新のスケジュールはこちらから
              </p>
            </div>
            <a
              href="https://lit.link/hatomugicha91"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="inline-flex items-center gap-2 px-7 py-2.5 border border-stone-300 text-stone-600 text-xs tracking-[0.3em] hover:bg-stone-800 hover:text-white hover:border-stone-800 transition-all duration-300 cursor-pointer whitespace-nowrap flex-shrink-0"
            >
              <i className="ri-external-link-line text-xs"></i>
              リンクを見る
            </a>
          </div>
        </div>

        {/* SNS */}
        <div>
          <div ref={snsHeadRef} style={snsHeadStyle} className="flex items-center gap-3 mb-5">
            <div className="w-7 h-7 flex items-center justify-center">
              <i className="ri-share-line text-stone-400 text-lg"></i>
            </div>
            <p className="text-xs tracking-[0.4em] text-stone-400 uppercase">SNS</p>
            <div className="flex-1 h-px bg-stone-200"></div>
          </div>

          <div ref={snsGridRef} className="grid grid-cols-1 md:grid-cols-3 gap-4 pl-10">
            {snsAccounts.map((acc, i) => (
              <a
                key={acc.id}
                href={acc.url}
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="bg-stone-50 p-5 flex flex-col gap-3 hover:bg-stone-100 transition-colors duration-200 cursor-pointer group"
                style={staggerStyle(snsVisible, i, 0.05, 0.12)}
              >
                <div className="flex items-center gap-2.5">
                  <div className={`w-8 h-8 flex items-center justify-center ${acc.iconBg} rounded-full flex-shrink-0`}>
                    <i className={`${acc.icon} ${acc.iconColor} text-sm`}></i>
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-1.5 mb-0.5">
                      <p className="text-xs text-stone-400 tracking-wider truncate">{acc.label}</p>
                      <span className={`text-[9px] px-1.5 py-0.5 rounded-full font-medium tracking-wider flex-shrink-0 ${acc.badgeColor}`}>{acc.badge}</span>
                    </div>
                    <p className="text-sm font-medium text-stone-700">{acc.handle}</p>
                  </div>
                </div>
                <p className="text-xs text-stone-500 leading-relaxed">{acc.desc}</p>
                <div className="flex items-center gap-1 text-xs text-stone-400 group-hover:text-stone-600 transition-colors mt-auto">
                  <span>フォローする</span>
                  <i className="ri-arrow-right-line text-xs"></i>
                </div>
              </a>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
}
